import {
  MunicipalityListView,
  MunicipalityNewView,
  MunicipalityEditView,
} from '@/views/authenticated/municipalities';

export default [
  {
    path: '/municipalities',
    name: 'app_municipality_list',
    meta: { title: 'Municipalities' },
    component: MunicipalityListView,
  },
  {
    path: '/municipalities/new',
    name: 'app_municipality_new',
    meta: { title: 'Add a Municipality' },
    component: MunicipalityNewView,
  },
  {
    path: '/municipalities/:municipality/edit',
    name: 'app_municipality_edit',
    meta: { title: 'Edit a Municipality' },
    component: MunicipalityEditView,
  },
];
